import { RequestComments as Comments, RequestsApi } from "api-client";
import Modal from "components/Modals/Modal";
import React, { useEffect, useState } from "react";
import RequestComment from "components/RequestComment/RequestComment";
import useSelector from "hooks/useSelector";
import { getAuthConfiguration } from "utils/getAuthConfiguration";
import { LoadingState } from "types/api";
import ModalError from "components/Error/ModalError";
import ModalLoading from "components/Loaders/ModalLoading";
import CloseButton from "components/Buttons/CloseButton";
import "./RequestComments.scss";
import { useIntl } from "react-intl";
import useSnackbar from "hooks/useSnackbar";
import { SnackbarType } from "types/snackbar";
import Divider from "components/Common/Divider";

interface RequestCommentsProps {
    requestId: string;
    isVisible: boolean;
    onCloseModal: () => void;
}

const RequestComments = ({requestId, isVisible, onCloseModal}: RequestCommentsProps) => {
    const intl = useIntl();
    const { addSnackbar } = useSnackbar();
    const apiBaseUrl = useSelector((state) => state.appConfiguration.apiBaseUrl);
    const requestApi = new RequestsApi(getAuthConfiguration(apiBaseUrl));
    const [commentStatus, setCommentStatus] = useState(LoadingState.idle);
    const [comments, setComments] = useState<Comments>();

    useEffect(() => {
        loadRequestComments();
    }, [requestId]);

    const loadRequestComments = async () => {
        try {
            setCommentStatus(LoadingState.loading);
            const res = await requestApi.getCommentsByRequestApiRequestsRequestCommentsGet({requestId: requestId, page: 1});
            setComments(res);
            setCommentStatus(LoadingState.success);
        } catch (error) {
            addSnackbar({
                type: SnackbarType.Error,
                message: `Failed to load conversation of ticket: ${requestId}`,
            });
            setCommentStatus(LoadingState.failure);
        }
    }

    if (commentStatus === LoadingState.failure) {
        return <ModalError closeModal={onCloseModal} />;
    }

    if (commentStatus === LoadingState.loading) {
        return <ModalLoading />;
    }

    if (!comments) {
        return null;
    }

    return (
        <Modal isVisible={isVisible} onClickBackdrop={onCloseModal} classes={{container: "comment-modal-container"}} >
            <CloseButton className="comment-modal-container__close-button" handleClose={onCloseModal} />
            <div className="comment-modal-header">
                <h2 className="comment-modal-header__title">Ticket #{requestId}</h2>
                <p className="comment-modal-header__disclaimer">
                    {intl.formatMessage({
                        id: "case_management.request_table.disclaimer",
                    },
                    {
                        br: <br/>
                    }
                    )}
                </p>
                <Divider />
            </div>
            <div className="comment-modal-body">
                {comments?.comments.map((comment) => (
                    <RequestComment
                        key={comment.commentId}
                        author={comment.author}
                        timestamp={comment.timestamp}
                        content={comment.content}
                    />
                ))}
            </div>
        </Modal>
    )
}

export default RequestComments;
